import { PayloadAction } from '@reduxjs/toolkit'
import {
  ConvenienceTestAnswer,
  ConvenienceTestDraftResponse,
  ConvenienceTestQuestion,
  ConvenienceTestQuestionnaire,
} from '@repo/user-types'
import { put, select, takeEvery } from 'redux-saga/effects'
import {
  convenienceTestsDraftHasErrorSelector,
  convenienceTestsDraftSelector,
} from '../../selectors'
import {
  convenienceTestQuestionnaireActions,
  convenienceTestQuestionnaireAnswersActions,
} from '../../slices'

export const buildConvenienceTestAnswersFromQuestions = ({
  questions,
  answers,
}: {
  questions: ConvenienceTestQuestion[]
  answers: ConvenienceTestAnswer[]
}): ConvenienceTestAnswer[] => {
  const answersMap = new Map(
    answers.map((answer) => [`${answer.stage}-${answer.questionId}-${answer.answerId}`, answer]),
  )

  return questions.map((question) => {
    const answerKey = `${question.stage}-${question.questionId}-${question.answerId}`

    return (
      answersMap.get(answerKey) ?? {
        answer: null,
        answerId: question.answerId,
        extraAnswer: null,
        extraAnswers: null,
        questionId: question.questionId,
        stage: question.stage,
      }
    )
  })
}

function* initializeConvenienceTestAnswers(
  action: { error: boolean } & PayloadAction<ConvenienceTestQuestionnaire | null>,
) {
  const hasDraft: ConvenienceTestDraftResponse = yield select(convenienceTestsDraftSelector)
  const hasDraftError: boolean = yield select(convenienceTestsDraftHasErrorSelector)
  if (hasDraft && !hasDraftError) {
    return
  }
  if (!action.error) {
    const payload = action.payload

    yield put(
      convenienceTestQuestionnaireAnswersActions.initialize(
        buildConvenienceTestAnswersFromQuestions({
          questions: payload?.questions ?? [],
          answers: payload?.answers ?? [],
        }),
      ),
    )
  }
}

export function* watchInitializeConvenienceTestAnswers() {
  yield takeEvery(
    convenienceTestQuestionnaireActions.getResponse.type,
    initializeConvenienceTestAnswers,
  )
}
